module.exports = __webpack_public_path__ + "img/banner-principal-decorativo-1.ab808678.svg";